import { render, staticRenderFns } from "./phone_login.vue?vue&type=template&id=0e4760a0&scoped=true&"
import script from "./phone_login.vue?vue&type=script&lang=js&"
export * from "./phone_login.vue?vue&type=script&lang=js&"
import style0 from "./phone_login.vue?vue&type=style&index=0&id=0e4760a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4760a0",
  null
  
)

export default component.exports